'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesTotals = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _currencies = require('../../../utils/currencies');

var fetchEvent = function fetchEvent(id) {
  return (0, _client.get)('v1/event/' + id + '/pages').then(function (response) {
    return response.totalFundraisingPages;
  });
};

var fetchPagesTotals = exports.fetchPagesTotals = function fetchPagesTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      return Array.isArray(params.event) ? Promise.all(params.event.map(_params.getUID).map(fetchEvent)).then(function (events) {
        return events.reduce(function (acc, total) {
          return acc + total;
        }, 0);
      }) : fetchEvent((0, _params.getUID)(params.event));
    default:
      return (0, _client.get)('donationsleaderboards/v1/leaderboard', _extends({}, params, {
        currencyCode: (0, _currencies.currencyCode)(params.country)
      }), {
        mappings: {
          charity: 'charityIds',
          campaign: 'campaignGuids',
          page: 'pageGuids',
          excludePageIds: 'excludePageGuids',
          limit: 'take'
        }
      }, { paramsSerializer: _params.paramsSerializer }).then(function (data) {
        return data.totalResults;
      });
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages-totals/justgiving/index.js
// module id = 1421
// module chunks = 0